// extracted by mini-css-extract-plugin
export default {"link":"styles_link__foyRX","linkTitle":"styles_linkTitle__ZvMWA","linkImage":"styles_linkImage__hPrZd","linkDecoration":"styles_linkDecoration__XTN2Z"};